import React from 'react';
import classNames from 'classnames';
import '../SuiteForm/Components/SuiteAreas/SuiteAreas.scss';
import '../SuiteForm/Checkbox.scss';
import FontAwesomeIcon from '../Icon';
import Col from '../Col';
import Row from '../Row';

interface SuiteAreasProps {
  disabled?: boolean;
  label?: string;
  id?: any;
  value?: any;
  textValue?: string;
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: () => void;
  onAddArea?: () => void;
  [key: string]: any;
}

const SuiteAreas = ({
  disabled,
  label,
  id,
  value,
  textValue,
  onInputChange,
  onChange,
  onAddArea,
}: SuiteAreasProps) => {
  const isChecked: boolean = Boolean(value);
  const isOtherPlaceholder: boolean = id === 'Other';

  const handleAddAreaClick = (): void => {
    const trimmedText: string = (textValue ?? '').trim();

    if (trimmedText === '') {
      alert('Please Enter custom label name for adding other check box');
      return;
    }

    onAddArea?.();
  };

  return (
    <div className="checkbox">
      <Row>
        <Col md="5" style={{ paddingLeft: '1.2rem' }}>
          <label className="checkbox-label">
            {label ?? 'Other'}
            <input
              className="checkbox__control"
              type="checkbox"
              id={id}
              checked={isChecked}
              onChange={() => onChange?.()}
            />
            <span
              className={classNames('checkmark', {
                'checkmark--checked': isChecked,
              })}
            >
              <FontAwesomeIcon glyph="check" weight="regular" />
            </span>
          </label>
        </Col>
        <Row>
          <Col md={7} style={{ paddingLeft: '1.3rem' }}>
            <input
              className="title__control"
              type="text"
              value={textValue}
              placeholder="Custom Label"
              onChange={onInputChange}
              disabled={disabled}
            />
          </Col>
        </Row>
        {isOtherPlaceholder && (
          <button
            type="button"
            className="add-area-button"
            onClick={handleAddAreaClick}
          >
            <FontAwesomeIcon glyph="plus-circle" weight="light" size="small" />
          </button>
        )}
      </Row>
    </div>
  );
};

export default SuiteAreas;
